import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertaConsultenosComponent } from './alerta-consultenos/alerta-consultenos.component';
import { BotonSecundarioComponent } from './boton-secundario/boton-secundario.component';
import { CampoDefaultComponent } from './campo-default/campo-default.component';
import { CampoTextoComponent } from './campo-texto/campo-texto.component';
import { ComboDefaultComponent } from './combo-default/combo-default.component';
import { ComboEspecialCorreoComponent } from './combo-especial-correo/combo-especial-correo.component';
import { EnlaceBackComponent } from './enlace-back/enlace-back.component';
import { GrupoRadiobuttonComponent } from './grupo-radiobutton/grupo-radiobutton.component';
import { ItemCorreoComponent } from './item-correo/item-correo.component';
import { TituloH1Component } from './titulo-h1/titulo-h1.component';
import { FormsModule } from '@angular/forms';
import { TituloH2Component } from './titulo-h2/titulo-h2.component';
import { TerminosCondicionesComponent } from './terminos-condiciones/terminos-condiciones.component';
import { BotonPrimarioComponent } from './boton-primario/boton-primario.component';
import { AlertaErrorComponent } from './alerta-error/alerta-error.component';
import { ErrorSeguimientoComponent } from './error-seguimiento/error-seguimiento.component';
import { PieComponent } from './pie/pie.component';
import { CabezalComponent } from './cabezal/cabezal.component';
import { BotonFlotanteComponent } from './boton-flotante/boton-flotante.component';
import { MensajeErrorComponent } from './mensaje-error/mensaje-error.component';
import { BuscadorChico } from './buscador-chico/buscador-chico.component';
import { EnlaceIconoIzquierdaChico } from './enlace-icono-izquierda-chico/enlace-icono-izquierda-chico.component';
import { IconoFlechaIzdaChico } from './icono-flecha-izda-chico/icono-flecha-izda-chico.component';
import { IconoLupaChico } from './icono-lupa-chico/icono-lupa-chico.component';
import { IconoPunteoChico } from './icono-punteo-chico/icono-punteo-chico.component';
import { IconoPunteoChicoDeshabilitado } from './icono-punteo-chico-deshabilitado/icono-punteo-chico-deshabilitado.component';
import { OpcionesComboEmpresaComponent } from './opciones-combo-empresa/opciones-combo-empresa.component';
import { ResultadoComboEmpresa } from './resultado-combo-empresa/resultado-combo-empresa.component';
import { BotonSecundarioParamImgComponent } from './boton-secundario-param-img/boton-secundario-param-img.component';
import { CampoDefaultAdminComponent } from './campo-default-admin/campo-default-admin.component';
import { GenericSelectComponent } from './generic-select/generic-select.component';
import { LoaderComponent } from './loader/loader.component';
import { AdjuntarArchivoComponent } from './adjuntar-archivo/adjuntar-archivo.component';
import { ArchivoAgregadoComponent } from './archivo-agregado/archivo-agregado.component';
import { BotonPrimarioConsultaComponent } from './boton-primario-consulta/boton-primario-consulta.component';
import { SnippetEmpresaComponent } from './snippet-empresa/snippet-empresa.component';
import { SelectorEmpresaComponent } from './selector-empresa/selector-empresa.component';
import { BotonSecundarioConsultaComponent } from './boton-secundario-consulta/boton-secundario-consulta.component';
import { BotonTerciarioConsultaComponent } from './boton-terciario-consulta/boton-terciario-consulta.component';
import { ExtendedModule } from "@angular/flex-layout";
import { ItemCategoriaComponent } from './menu-arbol/item-categoria/item-categoria.component';
import { ItemPreguntaComponent } from './menu-arbol/item-pregunta/item-pregunta.component';
import { ErrorPieComponent } from './menu-arbol/error-pie/error-pie.component';
import { CanalesContactoComponent } from './menu-arbol/canales-contacto/canales-contacto.component';
import { IconoCandadoComponent } from './menu-arbol/icono-candado/icono-candado.component';

@NgModule({
  declarations: [
    AlertaConsultenosComponent,
    BotonSecundarioComponent,
    BotonPrimarioComponent,
    BotonSecundarioParamImgComponent,
    GenericSelectComponent,
    CampoDefaultComponent,
    CampoDefaultAdminComponent,
    CampoTextoComponent,
    ComboDefaultComponent,
    ComboEspecialCorreoComponent,
    EnlaceBackComponent,
    GrupoRadiobuttonComponent,
    ItemCorreoComponent,
    TituloH1Component,
    TituloH2Component,
    TerminosCondicionesComponent,
    BotonPrimarioComponent,
    AlertaErrorComponent,
    ErrorSeguimientoComponent,
    PieComponent,
    CabezalComponent,
    BotonFlotanteComponent,
    MensajeErrorComponent,
    BuscadorChico,
    EnlaceIconoIzquierdaChico,
    IconoFlechaIzdaChico,
    IconoLupaChico,
    IconoPunteoChico,
    IconoPunteoChicoDeshabilitado,
    OpcionesComboEmpresaComponent,
    ResultadoComboEmpresa,
    TituloH1Component,
    GenericSelectComponent,
    LoaderComponent,
    AdjuntarArchivoComponent,
    ArchivoAgregadoComponent,
    BotonPrimarioConsultaComponent,
    SnippetEmpresaComponent,
    SelectorEmpresaComponent,
    BotonSecundarioConsultaComponent,
    BotonTerciarioConsultaComponent,
    ItemCategoriaComponent,
    ItemPreguntaComponent,
    ErrorPieComponent,
    CanalesContactoComponent,
    IconoCandadoComponent
  ],
  exports: [
    AlertaConsultenosComponent,
    BotonSecundarioComponent,
    BotonPrimarioComponent,
    BotonSecundarioParamImgComponent,
    GenericSelectComponent,
    CampoDefaultComponent,
    CampoDefaultAdminComponent,
    CampoTextoComponent,
    ComboDefaultComponent,
    ComboEspecialCorreoComponent,
    EnlaceBackComponent,
    GrupoRadiobuttonComponent,
    ItemCorreoComponent,
    TituloH1Component,
    TituloH2Component,
    TerminosCondicionesComponent,
    BotonPrimarioComponent,
    AlertaErrorComponent,
    ErrorSeguimientoComponent,
    PieComponent,
    CabezalComponent,
    BotonFlotanteComponent,
    MensajeErrorComponent,
    BuscadorChico,
    EnlaceIconoIzquierdaChico,
    IconoFlechaIzdaChico,
    IconoLupaChico,
    IconoPunteoChico,
    IconoPunteoChicoDeshabilitado,
    OpcionesComboEmpresaComponent,
    ResultadoComboEmpresa,
    AdjuntarArchivoComponent,
    ArchivoAgregadoComponent,
    BotonPrimarioConsultaComponent,
    SnippetEmpresaComponent,
    SelectorEmpresaComponent,
    BotonSecundarioConsultaComponent,
    BotonTerciarioConsultaComponent,
    ItemCategoriaComponent,
    ItemPreguntaComponent,
    ErrorPieComponent,
    CanalesContactoComponent,
    IconoCandadoComponent
  ],
  bootstrap: [
    AlertaConsultenosComponent,
    BotonSecundarioComponent,
    CampoDefaultComponent,
    CampoTextoComponent,
    ComboDefaultComponent,
    ComboEspecialCorreoComponent,
    EnlaceBackComponent,
    GrupoRadiobuttonComponent,
    ItemCorreoComponent,
    TituloH1Component,
    TituloH2Component,
    TerminosCondicionesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    //AppRoutingModule,
    ExtendedModule
  ]
})
export class BasecomponentsModule { }
